import {iToastTemplates} from "./interfaces";
import {Icon} from "assets/Icon";

export const ToastTemplates: iToastTemplates = {
  success: {
    text: "Success",
    icon: <Icon name="success" color="green" />,
    type: "success"
  },
  error: {
    text: "Error",
    icon: <Icon name="error" color="red" />,
    type: "error"
  },
  info: {
    text: "Info",
    icon: <Icon name="info" color="gray" />,
    type: "info"
  },
  warning: {
    text: "Warning",
    icon: <Icon name="warning" color="yellow" />,
    type: "warning"
  }
};
